<template>
    <div id="main"
         class="app-main">
        <router-view></router-view>

    </div>
</template>
<script>

export default {
    components: {}
}
</script>
<style>
@import "style/common.scss";
body {
    margin: 0px;
}
.app-main {
    width: 100%;
    height: 100%;
}
.flex-center {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
}
.text-blue {
    color: #0081ff;
}
.text-red {
    color: #ff6347;
}
</style>
